<template>
  <div id="app">
    <router-view/>
    
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style lang='scss'>
@import './assets/styles/variables';
@import './assets/styles/bootstrap';
@import 'node_modules/bootstrap-vue/src/index.scss';
@import './assets/styles/vue-select';
@import './assets/styles/custom';
@import './assets/styles/form-validation';


/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 4px;
}

*::-webkit-scrollbar-track {
  background: #e2e2e2;
}

*::-webkit-scrollbar-thumb {
  background-color: #717171;
    border-radius: 20px;
}


</style>
<style src="./styles/styleApp.css"></style>